import z from 'zod';

export const SettingIdSchema = z.enum(['emailerService'] as const);

export const SettingSchema = z.object({
  id: SettingIdSchema,
  value: z.string(),
});

export type SettingDto = z.infer<typeof SettingSchema>;
